import React, { useEffect } from "react";
import { useState } from "react";
import ReusableTest from "./Writing/ReusableTest";
import { useParams } from "react-router-dom";

function Writing(props) {
  const data = useParams();
  const [we, setWe] = useState(true);
  const [wemail, setWemail] = useState(true);
  const [swt, setSwt] = useState(true);
  const [currentCategory, setCurrentCategory] = useState();
  const [currentIndex, setCurrentIndex] = useState();
  const isCore = props.pteType === "core";

  

  useEffect(() => {
    props.setCategory(currentCategory);
    props.setIndex(currentIndex);
  }, [currentCategory, currentIndex, props]);
  useEffect(() => {
    if (isCore) {
      setWe(false);
    } else {
      setWemail(false);
    }
  }, [isCore]);

  useEffect(() => {
    if (!props.writing) {
      return;
    }
    if (props.writing.swt?.length === 0) {
      setSwt(false);
    }
    if (isCore) {
      if (props.writing.wemail?.length === 0) {
        setWemail(false);
      }
    } else if (props.writing.we?.length === 0) {
      setWe(false);
    }
  }, [props.writing, isCore]);

  return (
    <>
      {isCore ? (
        <>
          {wemail && (
            <ReusableTest
              mockId={data.id}
              mockType={props.mockType}
              pteType={props.pteType}
              testPost={props.writing.wemail}
              answer={props?.writingAnswer?.wemail}
              currentPage={props.currentPage}
              setCurrentPage={props.setCurrentPage}
              setCategoryState={setWemail}
              setSectionA={props.setSectionA}
              setCounterState={props.setCounterState}
              timerCounterDuration={540}
              setWritingState={props.setWritingState}
              setDetailDuration={props.setDetailDuration}
              setDetailAnswer={props.setDetailAnswer}
              setPause={props.setPause}
              pause={props.pause}
              category="wemail"
              setSave={props.setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              passSaveDataState={props.passSaveDataState}
              setPassSaveDataState={props.setPassSaveDataState}
              error={props.error}
              setError={props.setError}
              checkAnswerState={props.checkAnswerState}
            ></ReusableTest>
          )}
          {!wemail && swt && (
            <ReusableTest
              mockId={data.id}
              mockType={props.mockType}
              pteType={props.pteType}
              testPost={props.writing.swt}
              answer={props?.writingAnswer?.swt}
              currentPage={props.currentPage}
              setCurrentPage={props.setCurrentPage}
              setCategoryState={setSwt}
              timerCounterDuration={600}
              setSectionA={props.setSectionA}
              setCounterState={props.setCounterState}
              setWritingState={props.setWritingState}
              setDetailDuration={props.setDetailDuration}
              detailDuration={props.detailDuration}
              setDetailAnswer={props.setDetailAnswer}
              detailAnswer={props.detailAnswer}
              setPause={props.setPause}
              pause={props.pause}
              category="swt"
              setSave={props.setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              passSaveDataState={props.passSaveDataState}
              setPassSaveDataState={props.setPassSaveDataState}
              error={props.error}
              setError={props.setError}
              checkAnswerState={props.checkAnswerState}
            ></ReusableTest>
          )}
        </>
      ) : (
        <>
          {swt && (
            <ReusableTest
              mockId={data.id}
              mockType={props.mockType}
              pteType={props.pteType}
              testPost={props.writing.swt}
              answer={props?.writingAnswer?.swt}
              currentPage={props.currentPage}
              setCurrentPage={props.setCurrentPage}
              setCategoryState={setSwt}
              timerCounterDuration={600}
              setSectionA={props.setSectionA}
              setCounterState={props.setCounterState}
              setWritingState={props.setWritingState}
              setDetailDuration={props.setDetailDuration}
              detailDuration={props.detailDuration}
              setDetailAnswer={props.setDetailAnswer}
              detailAnswer={props.detailAnswer}
              setPause={props.setPause}
              pause={props.pause}
              category="swt"
              setSave={props.setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              passSaveDataState={props.passSaveDataState}
              setPassSaveDataState={props.setPassSaveDataState}
              error={props.error}
              setError={props.setError}
              checkAnswerState={props.checkAnswerState}
            ></ReusableTest>
          )}
          {!swt && we && (
            <ReusableTest
              mockId={data.id}
              mockType={props.mockType}
              pteType={props.pteType}
              testPost={props.writing.we}
              answer={props?.writingAnswer?.we}
              currentPage={props.currentPage}
              setCurrentPage={props.setCurrentPage}
              setCategoryState={setWe}
              setSectionA={props.setSectionA}
              setCounterState={props.setCounterState}
              timerCounterDuration={1200}
              setWritingState={props.setWritingState}
              setDetailDuration={props.setDetailDuration}
              setDetailAnswer={props.setDetailAnswer}
              setPause={props.setPause}
              pause={props.pause}
              category="we"
              setSave={props.setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              passSaveDataState={props.passSaveDataState}
              setPassSaveDataState={props.setPassSaveDataState}
              error={props.error}
              setError={props.setError}
              checkAnswerState={props.checkAnswerState}
            ></ReusableTest>
          )}
        </>
      )}
    </>
  );
}

export default Writing;
